/* global toastr */
import React from 'react'
import { wrapView, split_list } from '../smart_bps/lib/utils'
import { format_date } from '../smart_bps/lib/utils'
import { stateToPropsSigur } from '../lib/stateToPropsSigur'
import { PROJECT_NAME } from './constants'
import { SigurModelView } from '../lib/SigurModelView'
import AttrInput from '../smart_bps/lib/attr_input'
import { SigurFilesBlock } from '../lib/SigurFilesBlock'
import { Panel } from '../smart_bps/lib/components'
import { store } from '../index'
import {RequiredFieldPopover} from "../lib/RequiredFieldPopover";

class ModelView extends SigurModelView {
    constructor(props) {
    super(props)
    this.fileBlockRef = React.createRef()
  }

  getDeleteConfirmTitle() {
    return 'Удаление контрагента'
  }

  getSectionId(idx) {
    return 'contractor-section-' + idx
  }

  /** Всё в левую колонку: кнопки, уведомления, блок реквизитов, форма (Основное, Юр. данные), события. */
  renderContentLeft() {
    const schema = this.getFormSchema()
    return [
      this.renderContentLeftAction(),
      this.renderNotifications(),
      this.object_id !== 0 && this.renderContractorSummary(),
      <div key="form-groups" className="mt-3">
        {schema.map((item, idx) => this.renderFormGroup(item, idx))}
      </div>,
      this.renderEventBlock(),
    ]
  }

  /** Правая колонка: только Файлы и Комментарии. */
  renderContentRight() {
    if (this.object_id === 0) return []
    const filesSchema = this.state.files_schema || []
    const blocks = []
    if (filesSchema.length > 0) {
      blocks.push(
        <div key="files" className="mb-3">
          {this.renderFileBlock(true)}
        </div>
      )
    }
    blocks.push(this.renderComments())
    return blocks
  }

  /** Показываем блоки формы (Основное и т.д.). */
  renderFormGroup(item, idx) {
    const tab_title = item[0]
    const group_title = item[1]
    const attr_names = item[2]
    const grCollapsed = (this.props.form_group_hidden || []).includes(group_title)
    const form_access = this.state.form_access || {}
    const attrs = this.props.attrs || {}
    const form_access_names = Object.keys(form_access)
    const editAllMode = this.state.edit_all_mode
    const attr_names_allowed = editAllMode
      ? attr_names.filter((name) => attrs[name])
      : attr_names.filter((name) => form_access_names.includes(name))

    if (attr_names_allowed.length === 0) return null

    let wide_attrs = []
    let short_attrs = []
    attr_names_allowed.forEach((attr_name) => {
      const attr = attrs[attr_name]
      if (!attr) return
      if (attr.data_type === 'table' || (attr.tags && attr.tags.includes('form_wide'))) {
        wide_attrs.push(attr)
      } else {
        short_attrs.push(attr)
      }
    })

    const toggleShow = (show) => {
      store.dispatch({ type: `${this.project_name}_block_toggle`, data: { title: group_title, show } })
    }

    const sectionId = this.getSectionId(idx)
    return (
      <div key={idx} id={sectionId} className="contractor-section mb-3">
        <Panel header={group_title} collapsed={grCollapsed} toggleShow={toggleShow}>
          <div className="row form-sm">
            {this.renderFormGroupInclude(item, 'top')}
            {short_attrs.length > 0 &&
              split_list(short_attrs, 2).map((rowAttrs, rowIdx) => (
                <div className="col-md-6" key={rowIdx}>
                  {rowAttrs.map((attr) => this.renderFormAttr(attr, true))}
                </div>
              ))}
            {wide_attrs.length > 0 && (
              <div className="col-md-12" key="wide">
                {wide_attrs.map((attr) => this.renderFormAttr(attr, false))}
              </div>
            )}
            {this.renderFormGroupInclude(item, 'bottom')}
          </div>
        </Panel>
      </div>
    )
  }

  renderDeleteConfirmModal() {
  if (!this.state.showDeleteModal) return null

  function canDeleteModalContent() {
    return (
      <div>
        <div className="modal-body sigur-delete-confirm-modal__body">
          <span className="sigur-delete-confirm-modal__icon ti ti-alert-triangle" aria-hidden="true" />
          <p className="sigur-delete-confirm-modal__text mb-0">
            Это действие нельзя будет отменить. Вы уверены, что хотите удалить карточку?
          </p>
        </div>
        <div className="modal-footer px-3">
          <button type="button" className="btn btn-primary p-2 me-1" onClick={this.confirmDeleteAndClose}>
            Удалить
          </button>
          <button type="button" className="btn btn-secondary p-2 me-1" onClick={this.closeDeleteConfirm}>
            Отменить
          </button>
        </div>
      </div>
    )
  }

  function cantDeleteModalContent() {
    return (
      <div>
        <div className="modal-body sigur-delete-confirm-modal__body">
          <span className="sigur-delete-confirm-modal__icon ti ti-alert-triangle" aria-hidden="true" />
          <p className="sigur-delete-confirm-modal__text mb-0">
            Невозможно удалить контрагента: существуют связанные с ним люди
          </p>
        </div>
      </div>
    )
  }

  return (
    <div
      className="sigur-delete-confirm-modal modal fade show"
      style={{ display: 'block' }}
      id="modal_delete_confirm"
      key="delete_confirm_modal"
    >
      <div className="sigur-delete-confirm-modal__backdrop" onClick={this.closeDeleteConfirm} aria-hidden="true" />

      <div className="modal-dialog sigur-delete-confirm-modal__dialog" role="document">
        <div className="modal-content sigur-delete-confirm-modal__content">
          <div className="modal-header sigur-delete-confirm-modal__header">
            <h5 className="modal-title sigur-delete-confirm-modal__title">
              {this.getDeleteConfirmTitle()}
            </h5>

            <button
              type="button"
              className="btn-close"
              onClick={this.closeDeleteConfirm}
              aria-label="Закрыть"
            />
          </div>

          {this.state.can_delete_document
            ? canDeleteModalContent.call(this)
            : cantDeleteModalContent.call(this)}
        </div>
      </div>
    </div>
  )
}

  /** Шапка «Карточка организации»: наименование и реквизиты только для чтения (как на Федресурсе). */
  renderContractorSummary() {
    const d = this.state.form_data || {}
    const name = d.name || d.full_name || '—'
    const rows = [
      ['ИНН', d.inn],
      ['ОГРН', d.ogrn],
      ['КПП', d.kpp],
      ['Адрес', d.legal_address],
      ['Статус', d.legal_status],
      ['Дата регистрации', d.registration_date ? format_date(d.registration_date) : null],
      ['Телефон', d.phone],
      ['E-mail', d.email],
      ['Сайт', d.site],
    ].filter(([, v]) => v != null && String(v).trim() !== '')

    return (
      <div className="card mb-3 contractor-summary-card">
        <div className="card-body">
          <h2 className="contractor-summary-title">{name}</h2>
          {rows.length > 0 && (
            <dl className="contractor-summary-dl row mb-0 mt-2">
              {rows.map(([label, value]) => (
                <div className="col-md-6 col-lg-4 mb-1" key={label}>
                  <dt className="text-muted small mb-0">{label}</dt>
                  <dd className="mb-0">{value}</dd>
                </div>
              ))}
            </dl>
          )}
        </div>
      </div>
    )
  }

  /** Без горизонтальных вкладок. */
  renderTabPanel() {
    return null
  }

  onInnChange(name, value) {
    const raw = value == null ? '' : String(value)
    const digits = raw.replace(/\D/g, '').slice(0, 12)
    this.formChange(name, digits)
  }

  /** Переопределяем поле ИНН: только цифры и максимум 12 символов. */
  renderFormAttr(attr, horizontal) {
    if (attr && attr.name === 'inn') {
      const form_access = this.state.form_access || {}
      const access = this.state.edit_all_mode ? 'edit' : form_access[attr.name]
      const data = this.state.form_data || {}
      const attr_error = this.state.form_errors && this.state.form_errors[attr.name]
      const attr_message = this.state.form_messages && this.state.form_messages[attr.name]
      const requiredFields = this.state.required_fields || this.props.required_fields || []
      const required = Array.isArray(requiredFields) && requiredFields.includes(attr.name)
      const title = required && attr.title
        ? (
          <>
            {attr.title}{' '}
            <RequiredFieldPopover />
          </>
          )
        : attr.title

      return (
        <AttrInput
          key={attr.name}
          data_type="string"
          widget={attr.widget}
          choice_name={attr.choice_name}
          choices={this.props.choices}
          name={attr.name}
          title={title}
          value={data[attr.name] ?? ''}
          access={access}
          message={attr_message}
          error={attr_error}
          inner_attrs={attr.inner_attrs}
          horizontal={horizontal || false}
          tags={false}
          placeholder={attr.placeholder}
          onChange={(n, v) => this.onInnChange(n, v)}
        />
      )
    }

    return super.renderFormAttr(attr, horizontal)
  }

  hasPerm(perm) {
    return this.state.perms && this.state.perms.includes(perm)
  }

  renderTopPanelLeftItems() {
    return []
  }

}

export default wrapView(ModelView, (state) => stateToPropsSigur(state, PROJECT_NAME))
